import { useEffect, useState } from "react";

const useScrollSpy = (sectionIds, offset = 0) => {
  const [activeId, setActiveId] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      let current = "";
      sectionIds.forEach((id) => {
        const section = document.querySelector(id);
        if (section) {
          const top = section.offsetTop - offset;
          if (window.scrollY >= top) {
            current = id;
          }
        }
      });
      setActiveId(current);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // initialize
    return () => window.removeEventListener("scroll", handleScroll);
  }, [sectionIds, offset]);

  return activeId;
};

export default useScrollSpy;
